/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useRef } from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
// react-router components


// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";

// Soft UI Dashboard React examples
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import { useMenu } from "newContext/MenuContext";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Soft UI Dashboard React context
import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

// Images
import team2 from "assets/images/team-2.jpg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import { userLogout } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { BorderBottom, TryOutlined } from "@mui/icons-material";
import { ToastContainer,toast } from "react-toastify";

function DashboardNavbar({ absolute, light, isMini }) {
   const { setIsMenuOpen } = useMenu();
  
  const toastId= useRef(null)
  const navigate = useNavigate();
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const[userAccess,setUserAccess] = useState('');
  const[currentUser,setCurrentUser] = useState('');
  const[currentUserEmail,setCurrentUserEmail] = useState('');
  const[currentdatetime,setCurrentDatetime] = useState('');
  const [isActive,setIsActive]= useState(false);

  useEffect(()=>{
    let userDetails= localStorage.getItem("userdetails");
    let userDetailsArray= JSON.parse(userDetails)
    if(userDetailsArray){

      console.log("name is> ", userDetailsArray.name)
      setUserAccess(userDetailsArray.user_type);
      setCurrentUser(userDetailsArray.name);
      setCurrentUserEmail(userDetailsArray.email);
    }else{
      navigate('/');
    }
  },[])
  useEffect(() => {
    // Setting the navbar type
    var currentdate = new Date(); 
    var datetime = "Last Sync: " + currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/" 
                + currentdate.getFullYear() + " @ "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();
                setCurrentDatetime(datetime);
                if (localStorage.getItem('userid_details')) {            
    let session = localStorage.getItem('userid_details');
    let userDetails= localStorage.getItem("userdetails");
    let userDetailsArray= JSON.parse(userDetails)
    let userid_array =JSON.parse(session);
  if(userDetailsArray){

    console.log("name is> ", userDetailsArray.name)
    setUserAccess(userDetailsArray.user_type);
    setCurrentUser(userDetailsArray.name);
    setCurrentUserEmail(userDetailsArray.email);
  }else{
    navigate('/')
  }
                }
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = async() => 
  {
    setOpenMenu(false);
    let sessionCode = JSON.parse(localStorage.getItem('sessionCode'));
    let userDetails = JSON.parse(localStorage.getItem('userdetails'));
    setIsActive(TryOutlined)
    const body={
      userId: userDetails.id,
      sessionCode: sessionCode,
    }
    try{
      const response= await userLogout(body);
      const res=response.data;
      if(res.status){
        setIsActive(false)
        console.log("logged out ", res);
         if (!toast.isActive(toastId.current)) {
                toastId.current = toast.success(res.message, {
                  className: 'small-toast'
                });
              }
        localStorage.clear();
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }else{
        console.log("Could not logout ", res);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning(res.message, {
            className: 'small-toast'
          });
        }
        setIsActive(false)
      }
    }catch(e){
      console.log("error in logout", e);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(e.message, {
          className: 'small-toast'
        });
      }
      setIsActive(false)
    }
  }
 const handleClose = () =>
 {
  setOpenMenu(false);
 }
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClick={handleClose}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        title={[currentUser]}
        style={{borderBottom: '1px solid #e0e0e0', borderRadius: '0'}}
      />
       <NotificationItem
        title={[currentUserEmail]}
        style={{borderBottom: '1px solid #e0e0e0', borderRadius: '0'}}
      />

<NotificationItem
        color="secondary"
        title={["Change Password",]}
        onClick={() => {
          navigate('/authentication/reset-password');
        }}
        sx={{
          borderBottom: ({ borders: { borderWidth }, palette: { light, dark } }) => `${borderWidth[1]} solid ${light.main}`,
          backgroundColor: ({ palette: { light, dark } }) => (light.main, dark.main), 
        }}
        style={{borderBottom: '1px solid #e0e0e0', borderRadius: '0'}}
      />
      
      <NotificationItem
        color="secondary"
        title={["Sign out",]}
        onClick={handleCloseMenu}
 
      />
    </Menu>
  );

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <SimpleBackdrop openLoader={isActive} />
      <ToastContainer/>
      <Toolbar sx={(theme) => navbarContainer(theme)} style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
       
        <SoftBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
           
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </SoftBox>
        {isMini ? null : (
          <SoftBox sx={(theme) => navbarRow(theme, { isMini })}  style={{width:'auto'}}>
            {/* <SoftBox pr={1}>
              <SoftInput
                placeholder="Type here..."
                icon={{ component: "search", direction: "left" }}
              />
            </SoftBox> */}
            <SoftBox color={light ? "white" : "inherit"} style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                <div className="MuiBox-root" onClick={() =>{
 setIsMenuOpen(true)
 console.log("clicking on burger")
                }} style={{paddingTop:8, paddingRight:10, cursor:'pointer'}}><span className="material-icons-round notranslate MuiIcon-root MuiIcon-fontSizeMedium" aria-hidden="true">menu</span></div>
                <IconButton 
                size="big"
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
                >
                  <Icon
                    sx={({ palette: { dark, white } }) => ({
                      color: light ? white.main : dark.main,
                    })}
                  >
                    account_circle
                  </Icon>
                  <SoftTypography
                    variant="button"
                    fontWeight="medium"
                    color={light ? "white" : "dark"}
                  >
                    {currentUser}
                  </SoftTypography>
                </IconButton>
              
              
             
              {/* <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
              </IconButton> */}
              {renderMenu()}
            </SoftBox>
          </SoftBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
